<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="center1"><strong>AMIS ET ENNEMIS.<br/>DANGER ET MAGIE.<br/>VIE ET MORT.</strong></p>
<p class="nonindent">La plupart des jeunes feraient n’importe quoi pour réussir l’épreuve de fer.</p>
<p class="indent">Mais pas Callum Hunt. Lui, il souhaite plutôt échouer.</p>
<p class="indent">Toute sa vie, son père lui a dit de se tenir loin de la magie. Si Cal réussit l’épreuve de fer et qu’il est admis au Magisterium, il ne peut en résulter que des conséquences désastreuses. Il en est certain.</p>
<p class="indent">Il essaie donc de faire le moins bien possible – mais il ne réussit pas à échouer.</p>
<p class="indent">Et maintenant, le Magisterium l’attend. C’est un endroit à la fois sensationnel et sinistre, rattaché à son passé par de sombres liens et à son avenir par des voies tortueuses.</p>
<p class="indent">L’épreuve de fer n’est qu’un début, car l’épreuve la plus difficile reste à venir…</p>
<p class="extract">Un plongeon dans l’inconnu de la magie, fruit de l’imagination fertile de Holly Black et de Cassandra Clare, qui ont déjà publié de nombreux livres à succès – une histoire touchante et passionnante, qui défie l’imagination.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre.vue?09b2065a